<template>
  <b-overlay :show="isBusy">
    <b-container fluid>
      <b-row class="mt-3 mb-3">
        <b-col md="6" lg="12">
          <h3>Order Delivery</h3>
        </b-col>
      </b-row>
      <b-row>
        <b-col v-for="board in formattedBoard" :key="board.key">
          <b-card
            no-body
            :bg-variant="board.variant"
            class="rounded"
          >
            <b-card-header
              header-bg-variant="white"
              header-text-variant="dark"
              class="top-rounded"
            >
              <strong>{{ board.title }} ({{ board.items.length }})</strong>
              <b-button
                v-if="board.key === 'unassign'"
                size="sm"
                variant="warning"
                class="pull-right"
                @click="openCreateOrderModal"
              >
                Create Order
              </b-button>
              <b-button
                v-else-if="board.key === 'assigned_delivery'"
                size="sm"
                variant="success"
                class="pull-right"
                @click="openCreateShipmentModal"
              >
                Create
              </b-button>
            </b-card-header>
            <b-card-body class="p-2" body-text-variant="dark">
              <b-list-group v-if="board.key !== 'assigned_delivery'">
                <draggable
                  :ref="`draggable-${board.key}`"
                  :id="board.key"
                  :group="board.group"
                  :sort="false"
                  @end="onMoveOrder"
                  draggable=".list-group-item"
                >
                  <b-list-group-item
                    v-for="item in board.items"
                    :key="item.id"
                    :id="item.id"
                    class="p-0"
                  >
                    <b-card no-body class="no-border mb-0">
                      <b-card-header
                        v-if="isAssignedBoard(board)"
                        header-bg-variant="white"
                        header-text-variant="dark"
                      >
                        <div class="d-flex justify-content-between align-items-center">
                          <div class="d-flex flex-column">
                            <strong>{{ get(item, 'shipment.vehicle.reg_no', '') }}</strong>
                          </div>
                          <b-badge variant="info">{{ getShipmentStatus(item) }}</b-badge>
                          <b-dropdown
                            size="lg"
                            class="dropdown-button"
                            variant="link"
                            toggle-class="text-decoration-none"
                            no-caret
                          >
                            <template #button-content>
                              <span title="Action" class="fa fa-ellipsis-v"></span>
                            </template>
                            <b-dropdown-item @click="onClickEditOrder(item)">
                              <i class="text-primary fa fa-pencil-square-o"></i> Edit
                            </b-dropdown-item>
                            <b-dropdown-item @click="onClickDeleteOrder(item)">
                              <i class="text-danger fa fa-trash-o"></i> Delete
                            </b-dropdown-item>
                          </b-dropdown>
                        </div>
                      </b-card-header>
                      <b-card-text class="px-3 py-2" @click="openOrderModal(board, item)">
                        <table class="w-100">
                          <tr>
                            <td><strong>{{ get(item, 'number', '') }}</strong></td>
                            <td v-if="isCancelledOrder(board, item)"><span class="float-right text-danger">Cancelled</span></td>
                          </tr>
                            <tr><td>{{ get(item, 'destination.name') }}</td>
                          </tr>
                        </table>
                      </b-card-text>
                    </b-card>
                  </b-list-group-item>
                </draggable>
              </b-list-group>
              <b-card
                v-for="(item, idx) in board.items"
                no-body
                class="no-border"
                :class="{
                  'mb-2': idx < board.items.length - 1,
                  'mb-0': idx >= board.items.length - 1,
                }"
                :key="`${item.id}-${idx}`"
                v-else
              >
                <b-card-header
                  v-if="isAssignedBoard(board)"
                  header-bg-variant="white"
                  header-text-variant="dark"
                >
                  <div class="d-flex justify-content-between align-items-center">
                    <div class="d-flex flex-column">
                      <strong>{{ get(item, 'vehicle.reg_no', '') }}</strong>
                    </div>
                    <b-badge variant="info">{{ getShipmentStatus(item) }}</b-badge>
                    <b-dropdown
                      size="lg"
                      class="dropdown-button"
                      variant="link"
                      toggle-class="text-decoration-none"
                      no-caret
                    >
                      <template #button-content>
                        <span title="Action" class="fa fa-ellipsis-v"></span>
                      </template>
                      <b-dropdown-item @click="onClickEditShipment(item)">
                        <i class="text-primary fa fa-pencil-square-o"></i> Edit
                      </b-dropdown-item>
                      <b-dropdown-item @click="onClickDeleteShipment(item)">
                        <i class="text-danger fa fa-trash-o"></i> Delete
                      </b-dropdown-item>
                    </b-dropdown>
                  </div>
                </b-card-header>
                <b-card-text class="px-3 py-2">
                  <b-list-group>
                    <draggable
                      :ref="`draggable-${board.key}`"
                      :id="`shipment-${item.id}`"
                      :group="item.group"
                      :sort="false"
                      @end="onMoveOrder"
                      draggable=".list-group-item"
                    >
                      <b-list-group-item
                        v-for="order in item.orders"
                        :key="order.id"
                        :id="order.id"
                        class="p-0"
                      >
                        <b-card no-body class="no-border mb-0">
                          <b-card-text class="px-3 py-2" @click="openOrderModal(board, order)">
                            <table class="w-100">
                              <tr>
                                <td><strong>{{ get(order, 'number', '') }}</strong></td>
                                <td v-if="isCancelledOrder(board, order)"><span class="float-right text-danger">Cancelled</span></td>
                              </tr>
                                <tr><td>{{ get(order, 'destination.name') }}</td>
                              </tr>
                            </table>
                          </b-card-text>
                        </b-card>
                      </b-list-group-item>
                    </draggable>
                  </b-list-group>
                </b-card-text>
              </b-card>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
    <b-modal
      scrollable
      hide-footer
      size="lg"
      ref="order"
    >
      <template #modal-title v-if="selectedBoard">
        <h5 style="font-weight: bold; margin-bottom: 0px;">
          {{ get(selectedBoardItem, 'number', '') }}
          <b-badge :class="`bg-${get(selectedBoard, 'variant')}`">{{ get(selectedBoard, 'title') }}</b-badge>
        </h5>
      </template>
      <b-container class="text-left" v-if="selectedBoardItem">
        <b-row>
          <b-col :md="selectedBoard.key === 'completed' ? '12' : '10'" class="pr-4">
            <b-row class="mb-2">
              <b-col class="p-0">
                <h5 style="font-weight: bold;">Destination</h5>
                <p style="margin-bottom: 5px;">{{ get(selectedBoardItem, 'destination.name') }}</p>
              </b-col>
            </b-row>
            <b-row class="mb-4">
              <b-col class="p-0">
                <h5 style="font-weight: bold;">Location</h5>
                <p v-if="map.state === 'loading'">Please Wait</p>
                <l-map
                  v-else
                  ref="map"
                  @ready="onMapReady"
                  :style="getMapStyle()"
                  :bounds="map.bounds"
                  :zoom.sync="map.zoom"
                  :center="map.center"
                >
                  <l-tile-layer :url="map.url"></l-tile-layer>
                  <l-marker :lat-lng="getLatLng()" :icon="getIcon()">
                    <l-tooltip :options="map.tooltip">
                      <p style="margin-bottom: 0px;">{{ get(selectedBoardItem, 'customer.address.address1', '') }}</p>
                    </l-tooltip>
                  </l-marker>
                </l-map>
              </b-col>
            </b-row>
            <b-row>
              <b-col class="p-0">
                <div class="d-flex justify-content-between align-items-baseline">
                  <h5 style="font-weight: bold;">Activity</h5>
                  <b-button
                    variant="outline-primary"
                    size="sm"
                    @click="toggleActivity"
                  >
                    {{ activity.textButton }}
                  </b-button>
                </div>
                <table class="ml-2 activity" v-if="activity.show">
                 <tr v-if="loadingHistory">Loading Activity...</tr>
                  <tr
                    v-else
                    v-for="(history, index) in orderHistoriesFormatted"
                    :key="`history-${index}`"
                  >
                    <td v-html="formatHistory(history)"></td>
                  </tr>
                </table>
              </b-col>
            </b-row>
          </b-col>
          <b-col md="2" v-if="selectedBoard.key !== 'completed'">
            <b-row>
              <b-col class="p-0">
                <h5 style="font-weight: bold;">Actions</h5>
              </b-col>
            </b-row>
            <b-row>
              <b-col class="p-0">
                <b-button-group vertical class="d-block">
                  <b-button
                    variant="danger"
                    class="mb-2"
                    @click="deleteOrder"
                  >
                    <span class="pull-left">
                      <i class="fa fa-trash-o mr-2" aria-hidden="true"></i>Delete
                    </span>
                  </b-button>
                  <b-button
                    variant="outline-primary"
                    class="mb-2"
                    @click="onActionMove"
                    v-if="selectedBoard.key !== 'on_depot'"
                  >
                    <span class="pull-left">
                      <i class="fa fa-arrow-right mr-2" aria-hidden="true"></i>{{ getMoveText() }}
                    </span>
                  </b-button>
                  <b-button
                    v-else
                    id="popover-button-move"
                    @click="showPopoverMove = !showPopoverMove"
                    variant="outline-primary"
                    class="mb-2"
                  >
                    <span class="pull-left">
                      <i class="fa fa-arrow-right mr-2" aria-hidden="true"></i>Move
                    </span>
                  </b-button>
                  <b-popover
                    ref="popover"
                    @show="onShowPopoverMove"
                    @hidden="onHidePopoverMove"
                    placement="bottom"
                    :show.sync="showPopoverMove"
                    target="popover-button-move"
                    title="Select Shipment">
                    <b-list-group style="min-width: 250px;">
                      <b-list-group-item :class="`bg-${board.variant} mb-2 p-1 move-item`" v-for="board in targetMoveBoards" :key="board.key">
                        <strong>{{ `Set as ${board.title}` }}</strong>
                        <b-row>
                          <b-col md="8" class="pr-0">
                            <b-form-select
                              @click.native.stop
                              v-model="assignTarget"
                              :options="board.items"
                              value-field="id"
                              text-field="vehicle.reg_no"
                              size="sm"
                            />
                          </b-col>
                          <b-col md="4">
                            <b-button size="sm" variant="warning" @click="onChangeAssignTarget">Update</b-button>
                          </b-col>
                        </b-row>
                      </b-list-group-item>
                    </b-list-group>
                    <b-button @click="hideMovePopover" class="pull-right mt-2 mb-2" size="sm" variant="outline-warning">Cancel</b-button>
                  </b-popover>
                  <b-button
                    v-if="selectedBoard.key === 'assigned_pickup' || selectedBoard.key === 'assigned_delivery'"
                    id="popover-button-share"
                    @click="showPopoverShare = !showPopoverShare"
                    variant="outline-primary"
                    class="mb-2"
                  >
                    <span class="pull-left">
                      <i class="fa fa-share mr-2" aria-hidden="true"></i>Share
                    </span>
                  </b-button>
                  <b-popover
                    ref="popoverShare"
                    @show="onShowPopoverShare"
                    placement="bottom"
                    :show.sync="showPopoverShare"
                    target="popover-button-share">
                    <div class="row">
                      <div class="col-md-9">
                        <b-form-input
                          v-model="shareLink"
                          class="s-40"
                          @keydown="onShowPopoverShare"
                        />
                      </div>
                      <div class="col-md-3 pl-0">
                        <b-button
                          variant="primary"
                          @click="copy(shareLink); showPopoverShare = !showPopoverShare"
                          class="s-40"
                          block
                          :style="{'padding': '0px 5px'}"
                        >
                          Copy
                        </b-button>
                      </div>
                    </div>
                  </b-popover>
                </b-button-group>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-container>
    </b-modal>
    <b-modal
      :title="form.title"
      ref="vehicle"
      width="70%"
      hide-footer
      size="lg"
      @hidden="cancelAssignOrder"
    >
      <div class="container text-md-left">
        <div class="row" v-if="form.order">
          <div class="col-md-12">
            <label>Order Number</label>
            <b-form-input v-model="form.order.number" readonly class="mb-3" />
          </div>
        </div>
        <div class="row mb-3" v-if="!isDepotAndEmptyCustomer">
          <div class="col-md-12">
            <label>Vehicle</label>
            <multiselect
                name="vehicle"
                v-validate="'required'"
                :class="{'multiselect-danger': errors.has('vehicle')}"
                v-model="form.vehicle"
                :options="vehicles"
                label="reg_no"
                track-by="id"
                placeholder="Select Vehicle"
              />
          </div>
        </div>
        <div class="row mb-3" v-else>
          <div class="col-md-6">
            <label>Customer</label>
            <multiselect
                name="customer"
                v-validate="'required'"
                :class="{'multiselect-danger': errors.has('customer')}"
                v-model="form.customer"
                :options="customers"
                label="name"
                track-by="id"
                placeholder="Select Customer"
              />
          </div>
          <div class="col-md-6">
            <label>Destination</label>
            <multiselect
                name="destination"
                v-validate="'required'"
                :class="{'multiselect-danger': errors.has('destination')}"
                v-model="form.destination"
                :options="form.destinations"
                label="name"
                track-by="id"
                :disabled.sync="hasSelectedFormCustomer"
                placeholder="Select Destination"
              />
          </div>
        </div>
        <div class="row" v-if="isDepotAndEmptyCustomer">
          <div class="col-md-12">
            <div class="row mb-3">
              <div class="col-md-6">
                <b-form-checkbox
                  v-model="notif.set_customer"
                  :value="true"
                  :unchecked-value="false"
                > Send Email Notification </b-form-checkbox>
              </div>
            </div>
            <div class="row" v-if="notif.set_customer">
              <div class="col-md-6">
                <div class="row">
                  <div class="col-md-9 pr-0">
                    <b-form-input
                      v-model="notif.customer"
                      class="mb-3 s-40"
                      :disabled="notif.customerTextButton === 'Change'"
                      placeholder="Customer Email Notification"
                      v-validate="'required|email'"
                      type="email"
                      name="notif_customer"
                    />
                  </div>
                  <div class="col-md-3">
                    <b-button
                      variant="primary"
                      @click="setEmailNotif('customer')"
                      class="s-40"
                      :style="{'padding': '0px 5px'}"
                    >
                      {{ notif.customerTextButton }}
                    </b-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr class="mt-0">
      <b-button
        @click="cancelAssignOrder"
        variant="outline-secondary"
        class="pull-right">
        Cancel
      </b-button>
      <b-button
        @click="assignOrder"
        class="pull-left"
        variant="primary"
      >
        {{ form.textButton }}
      </b-button>
    </b-modal>
    <b-modal
      title="Create Order"
      ref="createOrder"
      width="70%"
      hide-footer
      size="lg"
      @hidden="cancelCreateOrder"
    >
      <div class="container text-md-left">
        <div class="row mb-3">
          <div class="col-md-12">
            <label>Order Number</label>
            <input
              type="text"
              name="order number"
              v-validate="'required'"
              :class="{'is-invalid': errors.has('order number')}"
              class="form-control s-40"
              id="number_order"
              placeholder="Input Number"
              v-model="order.number"
            >
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-md-6">
            <label>Client</label>
            <div class="row">
              <div class="col-md-9 pr-0">
                <multiselect
                  class="pr-0"
                  v-model="order.manufacturer"
                  :options="manufacturers"
                  label="name"
                  track-by="id"
                  placeholder="Select Client"
                />
              </div>
              <div class="col-md-3">
                <b-button variant="primary" @click="openActionCreateModal('Manufacturer')" class="s-40">Create</b-button>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <label>Destination</label>
            <div class="row">
              <div class="col-md-9 pr-0">
                <multiselect
                    v-model="order.manufacturer_destination"
                    :options="manufacturerDestinations"
                    label="name"
                    track-by="id"
                    :disabled.sync="hasSelectedManufacturer"
                    placeholder="Select Client Destination"
                  />
              </div>
              <div class="col-md-3">
                <b-button variant="primary" @click="openActionCreateModal('Manufacturer', true)" :disabled.sync="!order.manufacturer" class="s-40">Create</b-button>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="row mb-3">
              <div class="col-md-6">
                <b-form-checkbox
                  v-model="notif.set_manufacturer"
                  :value="true"
                  :unchecked-value="false"
                > Send Email Notification </b-form-checkbox>
              </div>
            </div>
            <div class="row" v-if="notif.set_manufacturer">
              <div class="col-md-6">
                <div class="row">
                  <div class="col-md-9 pr-0">
                    <b-form-input
                      v-model="notif.manufacturer"
                      class="mb-3 s-40"
                      :disabled="notif.manufacturerTextButton === 'Change'"
                      placeholder="Manufacturer Email Notification"
                      v-validate="'required|email'"
                      type="email"
                      name="notif_manufacturer"
                    />
                  </div>
                  <div class="col-md-3">
                    <b-button
                      variant="primary"
                      @click="setEmailNotif('manufacturer')"
                      class="s-40"
                      :style="{'padding': '0px 5px'}"
                    >
                      {{ notif.manufacturerTextButton }}
                    </b-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-md-3">
            <b-form-checkbox
              v-model="order.set_customer"
              :value="true"
              :unchecked-value="false"
              @change="isSetCustomer"
            > Set Customer </b-form-checkbox>
          </div>
        </div>
        <div class="row mb-3" v-if="order.set_customer">
          <div class="col-md-6">
            <label>Customer</label>
            <div class="row">
              <div class="col-md-9 pr-0">
                <multiselect
                    v-model="order.customer"
                    :options="customers"
                    label="name"
                    track-by="id"
                    placeholder="Select Customer"
                  />
              </div>
              <div class="col-md-3">
                <b-button variant="primary" @click="openActionCreateModal('Customer')" class="s-40">Create</b-button>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <label>Destination</label>
            <div class="row">
              <div class="col-md-9 pr-0">
                <multiselect
                    v-model="order.customer_destination"
                    :options="customerDestinations"
                    label="name"
                    track-by="id"
                    :disabled.sync="hasSelectedCustomer"
                    placeholder="Select Customer Destination"
                  />
              </div>
              <div class="col-md-3">
                <b-button variant="primary" @click="openActionCreateModal('Customer', true)" :disabled.sync="!order.customer" class="s-40">Create</b-button>
              </div>
            </div>
          </div>
        </div>
        <div class="row" v-if="order.set_customer">
          <div class="col-md-12">
            <div class="row mb-3">
              <div class="col-md-6">
                <b-form-checkbox
                  v-model="notif.set_customer"
                  :value="true"
                  :unchecked-value="false"
                > Send Email Notification </b-form-checkbox>
              </div>
            </div>
            <div class="row" v-if="notif.set_customer">
              <div class="col-md-6">
                <div class="row">
                  <div class="col-md-9 pr-0">
                    <b-form-input
                      v-model="notif.customer"
                      class="mb-3 s-40"
                      :disabled="notif.customerTextButton === 'Change'"
                      placeholder="Customer Email Notification"
                      v-validate="'required|email'"
                      type="email"
                      name="notif_customer"
                    />
                  </div>
                  <div class="col-md-3">
                    <b-button
                      variant="primary"
                      @click="setEmailNotif('customer')"
                      class="s-40"
                      :style="{'padding': '0px 5px'}"
                    >
                      {{ notif.customerTextButton }}
                    </b-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-md-6">
            <b-form-checkbox
              v-model="order.job_type"
              :value="true"
              :unchecked-value="false"
              :disabled="!order.set_customer"
            > Both Pickup and Delivery </b-form-checkbox>
          </div>
        </div>
      </div>
      <hr>
      <b-button
        @click="cancelCreateOrder"
        variant="outline-secondary"
        class="pull-right">
        Cancel
      </b-button>
      <b-button
        @click="createOrder"
        class="pull-left"
        variant="primary"
      >
        {{ order.textButton }}
      </b-button>
    </b-modal>
    <b-modal
      :title="`
        Create ${actionCreate.location.show
          ? `${actionCreate.type === 'Manufacturer' ? 'Client' : actionCreate.type} Location`
          : actionCreate.type
        }
      `"
      ref="actionCreate"
      width="75%"
      hide-footer
      size="lg"
    >
      <div class="container text-md-left">
        <div class="row" v-if="!actionCreate.location.show">
          <div class="container">
            <div class="row mb-3">
              <div class="col-md-12">
                <label>Name</label>
                <input
                  type="text"
                  class="form-control mb-2"
                  :placeholder="`Input ${actionCreate.type} Name`"
                  v-model="actionCreate.company.name"
                >
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-md-6">
                <label>Country</label>
                <input
                  type="text"
                  class="form-control mb-2"
                  placeholder="Input Country"
                  v-model="actionCreate.company.country"
                >
              </div>
              <div class="col-md-6">
                <label>State</label>
                <input
                  type="text"
                  class="form-control mb-2"
                  placeholder="Input State"
                  v-model="actionCreate.company.state"
                >
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-md-6">
                <label>City</label>
                <input
                  type="text"
                  class="form-control mb-2"
                  placeholder="Input City"
                  v-model="actionCreate.company.city"
                >
              </div>
              <div class="col-md-6">
                <label>Zip</label>
                <input
                  type="text"
                  class="form-control mb-2"
                  placeholder="Input Zip"
                  v-model="actionCreate.company.zip"
                >
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-md-12">
                <label>Address Line 1</label>
                <input
                  type="text"
                  class="form-control mb-2"
                  placeholder="Input Address Line 1"
                  v-model="actionCreate.company.address"
                >
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <label>Address Line 2</label>
                <input
                  type="text"
                  class="form-control mb-2"
                  placeholder="Input Address Line 2"
                  v-model="actionCreate.company.address1"
                >
              </div>
            </div>
          </div>
        </div>
        <div class="container" v-else>
          <div class="row mb-3">
            <div class="col-md-6">
              <label>Code</label>
              <input
                type="text"
                name="location code"
                class="form-control mb-2"
                placeholder="Location Code"
                v-model="actionCreate.location.code"
              >
            </div>
            <div class="col-md-6">
              <label>Name</label>
              <input
                type="text"
                class="form-control mb-2"
                placeholder="Location Name"
                v-model="actionCreate.location.name"
              >
            </div>
          </div>
          <div class="row">
            <b-col>
              <input
                class="form-control address_query"
                type="text"
                v-model="actionCreate.location.query"
                placeholder="Search Address"
              />
              <b-collapse id="suggestion" class="mt-1" :visible="actionCreate.location.openSuggestion">
                <b-card no-body class="mb-0">
                  <b-card-body class="p-2">
                    <p
                      class="card-text"
                      @click="selectLocation()"
                      style="cursor: pointer;"
                    >
                      {{ actionCreate.location.suggestion.formatted_address }}
                    </p>
                  </b-card-body>
                </b-card>
              </b-collapse>
              <l-map
                ref="actionCreateMap"
                @ready="onActionCreateMapReady"
                :style="getMapStyle()"
                :zoom="actionCreate.map.zoom"
                :center="actionCreate.map.center"
                @click="createMarker"
              >
                <l-tile-layer :url="actionCreate.map.url" />
                <l-marker
                  v-if="actionCreate.location.longitude && actionCreate.location.latitude"
                  :lat-lng="getMarkerPoint()"
                  :icon="getMarkerIcon()">
                  <l-tooltip :options="actionCreate.map.tooltip" v-if="get(actionCreate, 'location.suggestion.formatted_address', false)">
                    <p style="margin-bottom: 0px;">{{ get(actionCreate, 'location.suggestion.formatted_address', '') }}</p>
                  </l-tooltip>
                </l-marker>
              </l-map>
            </b-col>
          </div>
        </div>
      </div>
      <hr>
      <b-button
        @click="cancelActionCreate"
        variant="outline-secondary"
        class="pull-right">
        Cancel
      </b-button>
      <b-button
        @click="createAction"
        class="pull-left"
        variant="primary"
      >
        {{ actionCreate.textButton }}
      </b-button>
    </b-modal>
    <b-modal
      :title="shipment.title"
      ref="createShipment"
      width="70%"
      hide-footer
      size="lg"
      @hidden="cancelCreateShipment"
    >
      <div class="container text-md-left">
        <div class="row">
          <div class="col-md-12">
            <label>Shipment Number</label>
            <b-form-input v-model="shipment.number" readonly class="mb-3" />
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-md-12">
            <label>Vehicle</label>
            <multiselect
                name="vehicle"
                v-model="shipment.vehicle"
                :options="vehicles"
                label="reg_no"
                track-by="id"
                placeholder="Select Vehicle"
              />
          </div>
        </div>
      </div>
      <hr>
      <b-button
        @click="cancelCreateShipment"
        variant="outline-secondary"
        class="pull-right">
        Cancel
      </b-button>
      <b-button
        @click="createShipment"
        class="pull-left"
        variant="primary"
      >
        {{ shipment.textButton }}
      </b-button>
    </b-modal>
  </b-overlay>
</template>
<script>
import Multiselect from 'vue-multiselect';
import draggable from 'vuedraggable';
import L from 'leaflet';
import { LMap, LTileLayer, LMarker, LTooltip, LIcon } from 'vue2-leaflet';
import format from 'date-fns/format';
import get from 'lodash/get';
import uniqBy from 'lodash/uniqBy';
import concat from 'lodash/concat';
import isEmpty from 'lodash/isEmpty';
import filter from 'lodash/filter';
import startCase from 'lodash/startCase';
import camelCase from 'lodash/camelCase';
import debounce from 'lodash/debounce';
import find from 'lodash/find';
import padStart from 'lodash/padStart';
import cloneDeep from 'lodash/cloneDeep';
import isEqual from 'date-fns/is_equal/index';
import copy from 'copy-to-clipboard';

export default {
  components: {
    Multiselect,
    draggable,
    LMap,
    LTileLayer,
    LMarker,
    LTooltip,
    LIcon,
  },
  data() {
    return {
      isBusy: false,
      confirmDeleteOrder: false,
      showPopoverMove: false,
      targetMoveBoards: [],
      assignTarget: null,
      showPopoverShare: false,
      shareLink: '',
      boards: [
        {
          key: 'unassign',
          title: 'Unassigned',
          variant: 'warning',
          group: {
            name: 'unassign',
            pull: ['assigned_pickup'],
            put: ['assigned_pickup'],
          },
          items: [],
        },
        {
          key: 'assigned_pickup',
          title: 'Assigned For Pickup',
          variant: 'info',
          group: {
            name: 'assigned_pickup',
            pull: ['unassign'],
            put: ['unassign'],
          },
          items: [],
        },
        {
          key: 'on_depot',
          title: 'Depot',
          variant: 'primary',
          group: {
            name: 'on_depot',
            pull: [],
            put: [],
          },
          items: [],
        },
        {
          key: 'assigned_delivery',
          title: 'Assigned For Delivery',
          variant: 'success',
          group: {
            name: 'assigned_delivery',
            pull: ['on_depot'],
            put: ['on_depot'],
          },
          items: [],
        },
        {
          key: 'completed',
          title: 'Completed',
          variant: 'secondary',
          items: [],
        },
      ],
      selectedBoard: null,
      selectedBoardItem: null,
      map: {
        state: 'loading',
        url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        bounds: L.latLngBounds(
          { lat: 51.476483373501964, lng: -0.14668464136775586 },
          { lat: 51.52948330894063, lng: -0.019140238291583955 },
        ),
        center: [-28.86944, 153.04453],
        coordinates: [0, 0],
        zoom: 5,
        tooltip: {
          permanent: true,
          direction: 'top',
          offset: L.point(0, -30),
        },
      },
      activity: {
        show: false,
        textButton: 'Show Details',
      },
      shipment: {
        id: null,
        number: null,
        edit: false,
        title: 'Create Shipment',
        textButton: 'Save',
        vehicle: null,
      },
      form: {
        edit: false,
        title: 'Assign For Pickup',
        textButton: 'Save',
        context: null,
        vehicle: null,
        order: null,
        type: null,
        destinations: [],
        customer: null,
        destination: null,
      },
      manufacturers: [],
      manufacturerDestinations: [],
      customers: [],
      customerDestinations: [],
      order: {
        disabled: false,
        textButton: 'Save',
        manufacturer: null,
        manufacturer_destination: null,
        set_customer: false,
        customer: null,
        customer_destination: null,
        number: null,
        job_type: false,
      },
      notif: {
        manufacturerTextButton: 'Set Email',
        set_manufacturer: false,
        manufacturer: '',
        customerTextButton: 'Set Email',
        set_customer: false,
        customer: '',
      },
      timeoutCheckJobsInfo: 0,
      jobs: [],
      todayShipments: [],
      loadingHistory: false,
      orderHistories: [],
      isDelivery: false,
      actionCreate: {
        type: '',
        textButton: 'Save',
        company: {
          name: '',
          country: '',
          state: '',
          city: '',
          zip: '',
          address: '',
          address1: '',
          timezone: '',
        },
        location: {
          show: false,
          ask: true,
          ask_before: true,
          finish: false,
          openSuggestion: false,
          code: '',
          suggestion: '',
          query: '',
          name: '',
          address: '',
          longitude: '',
          latitude: '',
        },
        map: {
          url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
          center: [-28.86944, 153.04453],
          zoom: 5,
          tooltip: {
            permanent: true,
            direction: 'top',
            offset: L.point(0, -30),
          },
        },
      },
      set_shipment_after_customer: {
        api: '',
        payload: {},
        callback: null,
      },
    };
  },
  created() {
    this.$store.dispatch('vehicles/LOAD_INFO').then(() => {
      this.$store.commit('vehicles/SET_QUERY_COUNT', this.count_vehicle_all);
      this.$store.dispatch('vehicles/LOAD_DATA');
    });
    this.$store.commit('shipment_md/shipments/SET_QUERY_COUNT', 1e3);
    this.$store.dispatch('shipment_md/shipments/LOAD_DATA');
    this.$store.dispatch('shipment_md/orders/LOAD_LOCATIONS');
    this.loadCustomers();
    this.loadJobs();
  },
  mounted() {
    window.vm = this;
    this.toggleSidebar(false);
  },
  beforeDestroy() {
    clearTimeout(this.timeoutCheckJobsInfo);
    this.toggleSidebar(true);
  },
  computed: {
    vehicles() {
      return this.$store.getters['vehicles/vehicles'];
    },
    count_vehicle_all() {
      return this.$store.getters['vehicles/count_all'];
    },
    locations() {
      return this.$store.getters['shipment_md/orders/get_locations_data'];
    },
    hasSelectedManufacturer() {
      return !this.order.manufacturer || isEmpty(this.manufacturerDestinations);
    },
    hasSelectedCustomer() {
      return !this.order.customer || isEmpty(this.customerDestinations);
    },
    hasSelectedFormCustomer() {
      return !this.form.customer || isEmpty(this.form.destinations);
    },
    isSystemAdmin() {
      const { userData } = this.$store.getters;
      return userData.type === 'SYSTEM_ADMIN';
    },
    myCompany() {
      const { userData } = this.$store.getters;
      return userData.company_id;
    },
    myLocation() {
      return this.locations.find(location => location.code === 'TRT01');
    },
    orderHistoriesFormatted() {
      const data = [];

      this.orderHistories.forEach((history) => {
        let action = '';
        const { before, after } = history;
        const isBeforeShipment = get(before, 'shipment_id', null) !== null;
        const isAfterShipment = get(after, 'shipment_id', null) !== null;
        const afterShipmentId = get(after, 'shipment_id', null);
        const actionBy = get(history, 'action_by.full_name', '');
        const actionDate = format(get(history, 'updated_at'), 'DD MMMM YYYY HH:mm:ss');
        const typeHistory = get(history, 'type');

        if (isBeforeShipment && !isAfterShipment) {
          action = 'move this order to unassign';
        } else if (isBeforeShipment !== isAfterShipment && afterShipmentId) {
          action = `assigned this order to shipment <b>(ID: ${afterShipmentId})</b>`;
        } else if (typeHistory === 'ORDER_CREATE') {
          action = 'created job';
        } else if (typeHistory === 'ORDER_UPDATE') {
          Object.keys(before).forEach((key) => {
            if (key === 'metadata') {
              const metaBefore = get(before, 'metadata', {});
              const metaAfter = get(after, 'metadata', {});
              Object.keys(metaAfter).forEach((keyMeta) => {
                const beforeValMeta = get(metaBefore, keyMeta, '');
                const afterValMeta = get(metaAfter, keyMeta, '');
                const isChanged = beforeValMeta !== afterValMeta;
                if (keyMeta === 'confirmed' || keyMeta === 'pickup_confirmed') {
                  const confirmationReason = get(metaAfter, `${keyMeta}.notes`, '');
                  const beforeConfirmed = get(metaBefore, keyMeta, false);
                  const afterConfirmed = get(metaAfter, keyMeta, false);
                  const isConfirmed = !beforeConfirmed && afterConfirmed;
                  const confirmedBy = get(metaAfter, `${keyMeta}.name`, '');
                  if (isConfirmed) {
                    action = 'complete this order';
                    if (confirmationReason !== '') {
                      action += ` with reason <b>${confirmationReason}</b>`;
                    }
                    data.push({
                      action_by: confirmedBy,
                      action_name: action,
                      action_date: actionDate,
                    });
                    return false;
                  }
                }
                if (keyMeta === 'abort' || keyMeta === 'rejected') {
                  const isBeforeAbort = get(metaBefore, 'abort', false);
                  const isAfterAbort = get(metaAfter, 'abort', false);
                  const isCancelled = !isBeforeAbort && isAfterAbort;
                  if (isCancelled) {
                    const cancellationReason = get(metaAfter, `${keyMeta}.reason`, '');
                    const cancelledBy = get(metaAfter, `${keyMeta}.name`, '');
                    action = `${keyMeta} this order`;
                    if (cancellationReason !== '') {
                      action += ` with reason <b>${cancellationReason}</b>`;
                    }
                    data.push({
                      action_by: cancelledBy,
                      action_name: action,
                      action_date: actionDate,
                    });
                  }
                  return false;
                }
                if (typeof afterValMeta !== 'string' || !isChanged || action === '') {
                  return false;
                }
                data.push({
                  action_by: actionBy,
                  action_name: action,
                  action_date: actionDate,
                });
                return true;
              });
              return false;
            }
            if (action !== '' && action) {
              data.push({
                action_by: actionBy,
                action_name: action,
                action_date: actionDate,
              });
            }
            return true;
          });
          return false;
        }
        data.push({
          action_by: actionBy,
          action_name: action,
          action_date: actionDate,
        });
        return true;
      });
      return data;
    },
    isDepotAndEmptyCustomer() {
      const metadata = get(this.form.order, 'metadata', {});
      const isCustomer = get(metadata, 'customer_id', false);
      return this.isDelivery && !isCustomer;
    },
    formattedBoard() {
      const boards = cloneDeep(this.boards);
      return boards.map((board) => {
        if (board.key === 'on_depot') {
          const assignedDeliveryIdx = boards.findIndex(b => b.key === 'assigned_delivery');
          boards[assignedDeliveryIdx].items.forEach((i) => {
            board.group.pull.push(`shipment-${i.id}`);
            board.group.put.push(`shipment-${i.id}`);
          });
        } else if (board.key === 'assigned_delivery') {
          board.items.map((item) => {
            item.group.pull.push('on_depot');
            item.group.put.push('on_depot');
            const otherItems = board.items.filter(i => i.id !== item.id);
            otherItems.forEach((i) => {
              item.group.pull.push(`shipment-${i.id}`);
              item.group.put.push(`shipment-${i.id}`);
            });
            return item;
          });
        }
        return board;
      });
    },
  },
  watch: {
    'order.manufacturer': function watchOrderMmanufacturer(manufacturer) {
      const manufacturerId = !manufacturer ? null : manufacturer.id;
      this.setManufacturerDestinations(manufacturerId);
    },
    'order.customer': function watchOrderCustomer(customer) {
      const customerId = !customer ? null : customer.id;
      this.setCustomerDestinations(customerId);
    },
    'form.customer': function watchFormCustomer(customer) {
      const customerId = !customer ? null : customer.id;
      this.form.destinations.splice(0);
      this.form.destinations = filter(this.locations, { company: { id: customerId } });
      if (!isEqual(customerId, get(this.form.destination, 'company.id'))) {
        this.form.destination = {};
      }
    },
    'actionCreate.location.query': function watchActionCreateLocationQuery(query) {
      if (query === '' || this.actionCreate.location.finish) {
        this.actionCreate.location.query = '';
        this.actionCreate.location.openSuggestion = false;
        this.actionCreate.location.finish = false;
        return;
      }
      this.searchLocation(this, query);
    },
  },
  methods: {
    get,
    copy,
    onShowPopoverMove() {
      const allowedtargets = ['assigned_delivery'];
      this.targetMoveBoards = this.boards.filter(dt => allowedtargets.includes(dt.key));
    },
    onHidePopoverMove() {
      this.targetMoveBoards = [];
    },
    hideMovePopover() {
      this.$refs.popover.$emit('close');
    },
    onChangeAssignTarget() {
      let newMetadata = get(this.selectedBoardItem, 'metadata', {});
      if (newMetadata === null) newMetadata = {};
      const customerAssigned = get(newMetadata, 'customer_id', false);
      newMetadata.pickup_shipment_id = get(this.selectedBoardItem, 'shipment.id', null);
      newMetadata.manufacturer_id = get(this.selectedBoardItem, 'customer.id', null);
      newMetadata.manufacturer_location_id = get(this.selectedBoardItem, 'destination.id', null);
      newMetadata.time_in_pickup = get(this.selectedBoardItem, 'metadata.time_in', null);
      newMetadata.time_out_pickup = get(this.selectedBoardItem, 'metadata.time_out', null);
      newMetadata.time_in_app_pickup = get(this.selectedBoardItem, 'metadata.time_in_app', null);
      newMetadata.time_out_app_pickup = get(this.selectedBoardItem, 'metadata.time_out_app', null);

      const api = 'ADD_SHIPMENT_ORDER';
      const orderId = this.selectedBoardItem.id;
      const payload = {
        order_id: orderId,
        shipment_id: this.assignTarget,
      };
      const callback = (shipment) => {
        const orderObj = shipment.orders.find(o => o.id === orderId);
        this.$store.commit('shipment_md/orders/SET_DETAIL_ID', orderId);
        this.$store.dispatch('shipment_md/orders/UPDATE_DATA', {
          type: 'DELIVERY',
          metadata: newMetadata,
          customer: {
            id: get(orderObj, 'metadata.customer_id', ''),
          },
          destination: {
            id: get(orderObj, 'metadata.customer_location_id', ''),
          },
        })
          .then(() => {
            this.set_shipment_after_customer.active = false;
            this.loadJobs();
          });
      };

      this.$refs.order.hide();

      if (!customerAssigned) {
        this.isDelivery = true;
        this.form.type = 'DELIVERY';
        this.set_shipment_after_customer = {
          active: true,
          api,
          payload,
          callback,
        };
        this.notif = {
          manufacturerTextButton: 'Set Email',
          set_manufacturer: false,
          manufacturer: '',
          customerTextButton: 'Set Email',
          set_customer: false,
          customer: '',
        };
        return this.handleAssignOrder(orderId, 'Assign Customer For Delivery');
      }

      return this.runAndReloadShipmentApi(api, payload, callback);
    },
    onShowPopoverShare() {
      const trackingToken = get(this.selectedBoardItem, 'metadata.tracking_token', '');
      this.shareLink = `${process.env.TMS_CONFIG.BASE_URL}/#/tracking?code=${trackingToken}`;
    },
    hideMoveShare() {
      this.$refs.popoverShare.$emit('close');
    },
    toggleSidebar(show) {
      this.$store.commit('SHOW_HIDE_BREADCRUMB', show);
      this.$store.commit('SHOW_HIDE_FOOTER', show);
      if (show) {
        this.$store.commit('RESTORE_SIDEBAR');
        document.body.classList.remove('sidebar-minimized');
      } else {
        this.$store.commit('MINIMIZE_SIDEBAR');
        document.body.classList.add('sidebar-minimized');
      }
    },
    loadCustomers() {
      return Promise.all([
        this.$store.dispatch('companies/LOAD_SIMPLE_DATA', { tenants: 0 }),
        this.$store.dispatch('companies/LOAD_SIMPLE_DATA', { tenants: 1 }),
      ]).then((data) => {
        const companies = data[0] || [];
        const customers = companies.filter(dt => dt.type === 'CUSTOMER');
        const tenants = data[1];
        this.manufacturers = companies.filter(dt => dt.type === 'MANUFACTURER');
        this.customers = !this.isSystemAdmin ? uniqBy(concat(customers, tenants), 'id') : companies;
      });
    },
    loadJobsInfo(forceReload = false) {
      return this.$store.dispatch('shipment_md/orders/LOAD_JOBS2_INFO').then((data) => {
        let reloadJobData = false;

        data.forEach((jobInfo) => { // eslint-disable-line
          const { type, count } = jobInfo;
          const jobData = this.jobs.find(dt => dt.type === type);
          if (!jobData) { return false; }

          const jobItems = get(jobData, 'orders', []);
          const currentCount = jobItems.length;
          const isSameCount = Number(count) === Number(currentCount);

          if (!isSameCount) {
            reloadJobData = true;
            return true;
          }
        });

        if (reloadJobData || forceReload) {
          this.loadJobs();
          return Promise.resolve(data);
        }

        clearTimeout(this.timeoutCheckJobsInfo);
        this.timeoutCheckJobsInfo = setTimeout(() => {
          this.loadJobsInfo();
        }, 10e3);

        return Promise.resolve(data);
      });
    },
    resetBoard() {
      this.boards = [
        {
          key: 'unassign',
          title: 'Unassigned',
          variant: 'warning',
          group: {
            name: 'unassign',
            pull: ['assigned_pickup'],
            put: ['assigned_pickup'],
          },
          items: [],
        },
        {
          key: 'assigned_pickup',
          title: 'Assigned For Pickup',
          variant: 'info',
          group: {
            name: 'assigned_pickup',
            pull: ['unassign'],
            put: ['unassign'],
          },
          items: [],
        },
        {
          key: 'on_depot',
          title: 'Depot',
          variant: 'primary',
          group: {
            name: 'on_depot',
            pull: [],
            put: [],
          },
          items: [],
        },
        {
          key: 'assigned_delivery',
          title: 'Assigned For Delivery',
          variant: 'success',
          group: {
            name: 'assigned_delivery',
            pull: ['on_depot'],
            put: ['on_depot'],
          },
          items: [],
        },
        {
          key: 'completed',
          title: 'Completed',
          variant: 'secondary',
          items: [],
        },
      ];
    },
    loadJobs() {
      const today = format(new Date(), 'YYYY-MM-DD');
      this.isBusy = true;
      return Promise.all([
        this.$store.dispatch('shipment_md/orders/LOAD_JOBS2'),
        this.$store.dispatch('shipment_md/shipments/LOAD_TODAY_SHIPMENTS', today),
      ])
        .then(([jobs, todayShipments]) => {
          this.todayShipments = todayShipments.filter(shipment =>
            shipment.orders.length === 0 && shipment.state !== 'FINISH');
          this.jobs = jobs;
          this.resetBoard();
          jobs.forEach((job) => {
            const boardIndex = this.boards.findIndex(board => board.key === job.type);
            if (job.type === 'assigned_delivery') {
              if (job.orders.length === 0) {
                this.boards[boardIndex].items = [];
              } else {
                job.orders.forEach((order) => {
                  const itemIdx = this.boards[boardIndex].items.findIndex(i =>
                    i.id === order.shipment.id);
                  if (itemIdx === -1) {
                    this.boards[boardIndex].items.push({
                      id: order.shipment.id,
                      number: order.shipment.number,
                      vehicle: order.shipment.vehicle,
                      state: order.shipment.state,
                      group: {
                        name: `shipment-${order.shipment.id}`,
                        pull: [],
                        put: [],
                      },
                      orders: [order],
                    });
                  } else {
                    const isExistsOrder = this.boards[boardIndex].items[itemIdx].orders.find(o =>
                      o.id === order.id);
                    if (!isExistsOrder) this.boards[boardIndex].items[itemIdx].orders.push(order);
                  }
                });
              }
            } else {
              this.boards[boardIndex].items = job.orders;
            }
          });
          const boardIdx = this.boards.findIndex(board => board.key === 'assigned_delivery');
          this.todayShipments.forEach((shipment) => {
            const shipmentIdx = this.boards[boardIdx].items.findIndex(i =>
              parseInt(i.id, 10) === parseInt(shipment.id, 10));
            const shipmentJob = {
              id: shipment.id,
              number: shipment.number,
              vehicle: shipment.vehicle,
              state: shipment.state,
              orders: [],
              group: {
                name: `shipment-${shipment.id}`,
                pull: [],
                put: [],
              },
            };
            if (shipmentIdx === -1) {
              this.boards[boardIdx].items.push(shipmentJob);
            } else {
              this.boards[boardIdx].items[shipmentIdx] = shipmentJob;
            }
          });
          this.loadJobsInfo();
        })
        .finally(() => {
          setTimeout(() => {
            this.isBusy = false;
          }, 1e3);
        });
    },
    onClickEditShipment(shipment) {
      this.shipment = {
        id: shipment.id,
        edit: true,
        title: 'Edit Shipment',
        textButton: 'Save',
        vehicle: shipment.vehicle,
        number: shipment.number,
      };
      this.$refs.createShipment.show();
    },
    onClickDeleteShipment(shipment) {
      return this.$swal({
        title: 'Delete Confirmation',
        html: 'Are you sure want to delete this shipment?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        showCloseButton: true,
      }).then((result) => {
        if (result.value) {
          if (this.isBusy) return false;
          this.isBusy = true;
          return this.$store.dispatch('shipment_md/shipments/DELETE_DATA', shipment.id)
            .then(() => {
              this.$swal('Success', 'Successfully Delete Shipment.', 'info').then(() => {
                this.loadJobs();
              });
            })
            .finally(() => {
              this.isBusy = false;
            });
        }
        return false;
      });
    },
    openCreateShipmentModal() {
      this.shipment = {
        id: null,
        edit: false,
        title: 'Create Shipment',
        textButton: 'Save',
        vehicle: null,
        number: this.createShipmentNumber(),
      };
      this.$refs.createShipment.show();
    },
    openCreateOrderModal() {
      this.order = {
        mode: 'form',
        textButton: 'Save',
        manufacturer: null,
        manufacturer_destination: null,
        set_customer: false,
        customer: null,
        customer_destination: null,
        number: null,
        job_type: false,
      };
      this.notif = {
        manufacturerTextButton: 'Set Email',
        set_manufacturer: false,
        manufacturer: '',
        customerTextButton: 'Set Email',
        set_customer: false,
        customer: '',
      };
      this.$refs.createOrder.show();
    },
    openActionCreateModal(type, is_location = false) {
      this.actionCreate = {
        type,
        textButton: 'Save',
        company: {
          name: '',
          country: '',
          state: '',
          city: '',
          zip: '',
          address: '',
          address1: '',
          timezone: '',
        },
        location: {
          show: false,
          ask: true,
          ask_before: true,
          finish: false,
          openSuggestion: false,
          code: '',
          suggestion: '',
          query: '',
          name: '',
          address: '',
          longitude: '',
          latitude: '',
        },
        map: {
          url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
          center: [-28.86944, 153.04453],
          zoom: 5,
          tooltip: {
            permanent: true,
            direction: 'top',
            offset: L.point(0, -30),
          },
        },
      };
      this.$refs.actionCreate.show();
      if (is_location) {
        this.actionCreate.location.show = true;
        this.onActionCreateMapReady();
      }
    },
    createOrder() {
      const isOrderNumber = !isEmpty(this.order.number);
      const isManufacturer = !isEmpty(this.order.manufacturer);
      const isManufacturerDestination = !isEmpty(this.order.manufacturer_destination);
      let isCustomer = true;
      let isCustomerDestination = true;

      if (this.order.set_customer) {
        isCustomer = !isEmpty(this.order.customer);
        isCustomerDestination = !isEmpty(this.order.customer_destination);
      }

      if (isOrderNumber &&
          isManufacturer &&
          isManufacturerDestination &&
          isCustomer &&
          isCustomerDestination) {
        this.order.textButton = 'Saving';
        const payload = {
          number: this.order.number,
          company: {
            id: this.myCompany,
          },
          customer: this.order.manufacturer,
          destination: this.order.manufacturer_destination,
          type: 'PICKUP',
        };
        if (this.order.set_customer) {
          payload.metadata = {
            customer_id: this.order.customer.id,
            customer_location_id: this.order.customer_destination.id,
          };
          if (this.order.job_type) {
            payload.metadata.job_type = 'pickup_delivery';
          }
        }
        if (!isEmpty(this.notif.manufacturer) && this.checkIfValidaEmail(this.notif.manufacturer)) {
          payload.metadata = payload.metadata || {};
          payload.metadata.email_notification = payload.metadata.email_notification || {};
          payload.metadata.email_notification.manufacturer = this.notif.manufacturer;
        }
        if (!isEmpty(this.notif.customer) && this.checkIfValidaEmail(this.notif.customer)) {
          payload.metadata = payload.metadata || {};
          payload.metadata.email_notification = payload.metadata.email_notification || {};
          payload.metadata.email_notification.customer = this.notif.customer;
        }
        this.$store.dispatch('shipment_md/orders/CREATE_DATA', payload)
          .then(() => {
            setTimeout(() => {
              this.order.textButton = 'Success';
            }, 1e3);
          })
          .finally(() => {
            setTimeout(() => {
              this.cancelCreateOrder();
              this.loadJobs();
            }, 2e3);
          });
      }
    },
    createMarker(e) {
      if (!this.actionCreate.location.ask) {
        this.actionCreate.location.suggestion = {};
        this.actionCreate.location.longitude = e.latlng.lng;
        this.actionCreate.location.latitude = e.latlng.lat;
        return;
      }

      let msgWarning = 'Do you want to move the marker to the clicked position?';
      if (!this.actionCreate.location.longitude && !this.actionCreate.location.latitude) {
        msgWarning = 'Do you want to create the marker to the clicked position?';
      }
      this.$swal({
        title: 'Map Action',
        text: msgWarning,
        input: 'checkbox',
        inputValue: this.actionCreate.location.ask_before,
        inputPlaceholder: 'Don\'t ask me again',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        onOpen(el) {
          el.querySelector('.swal2-actions').style.marginTop = '0px';
        },
      }).then((result) => {
        if (Object.prototype.hasOwnProperty.call(result, 'value')) {
          this.actionCreate.location.ask = !result.value;
          this.actionCreate.location.ask_before = result.value;
          this.actionCreate.location.suggestion = {};
          this.actionCreate.location.longitude = e.latlng.lng;
          this.actionCreate.location.latitude = e.latlng.lat;
        }
        document.querySelector('.swal2-actions').style.margin = '1.25em auto 0';
      });
    },
    createAction() {
      if (this.actionCreate.location.show) {
        const isLocationCode = !isEmpty(this.actionCreate.location.code);
        const isLocationName = !isEmpty(this.actionCreate.location.name);
        const isLongitude = this.actionCreate.location.longitude !== '';
        const isLatitude = this.actionCreate.location.latitude !== '';
        if (isLocationCode && isLocationName && isLongitude && isLatitude) {
          const companyId = this.actionCreate.type === 'Manufacturer'
            ? this.order.manufacturer.id
            : this.order.customer.id;
          const payload = {
            company_id: companyId,
            type: 1,
            code: this.actionCreate.location.code,
            name: this.actionCreate.location.name,
            longitude: this.actionCreate.location.longitude,
            latitude: this.actionCreate.location.latitude,
            metadata: {
              radius: 75,
            },
            geometry: {
              type: 'Point',
              coordinates: [this.actionCreate.location.latitude, this.actionCreate.longitude],
            },
          };
          this.actionCreate.textButton = 'Saving';
          this.$store.dispatch('shipment_md/locations/CREATE_DATA', payload)
            .then(() => {
              this.actionCreate.textButton = 'Success';
              setTimeout(() => {
                this.cancelActionCreate();
                this.actionCreate.textButton = 'Save';
                setTimeout(() => {
                  this.$store.dispatch('shipment_md/orders/LOAD_LOCATIONS').then(() => {
                    if (this.actionCreate.type === 'Manufacturer') {
                      this.setManufacturerDestinations();
                    } else {
                      this.setCustomerDestinations();
                    }
                  });
                }, 2e3);
              }, 1e3);
            });
        }
      } else {
        const isName = !isEmpty(this.actionCreate.company.name);
        const isCountry = !isEmpty(this.actionCreate.company.country);
        if (isName && isCountry) {
          this.order.textButton = 'Saving';
          this.$store.dispatch('companies/CREATE_DATA', {
            name: this.actionCreate.company.name,
            type: this.actionCreate.type.toUpperCase(),
            address: {
              country: this.actionCreate.company.country,
              state: this.actionCreate.company.state,
              city: this.actionCreate.company.city,
              address1: this.actionCreate.company.address,
              address2: this.actionCreate.company.address1,
              zip_code: this.actionCreate.company.zip,
            },
          })
            .then(() => {
              this.actionCreate.textButton = 'Success';
              setTimeout(() => {
                this.cancelActionCreate();
                this.actionCreate.textButton = 'Save';
                setTimeout(() => {
                  this.loadCustomers();
                }, 2e3);
              }, 1e3);
            });
        }
      }
    },
    createShipmentNumber() {
      const today = format(new Date(), 'YYYY-MM-DD');
      const prefix = today.split('-').join('');
      return `${prefix}${padStart(this.todayShipments.length + 1, 3, '0')}`;
    },
    createShipment() {
      const isVehicle = !isEmpty(this.shipment.vehicle);
      if (isVehicle) {
        let method = 'CREATE_DATA';
        this.isBusy = true;
        this.shipment.textButton = 'Saving';
        const payload = {
          number: this.shipment.number,
          vehicle: this.shipment.vehicle,
          driver_id: get(this.shipment, 'vehicle.driver.id', null),
          company: {
            id: this.myCompany,
          },
          origin: this.myLocation,
          type: 0,
        };
        if (this.shipment.edit) {
          this.$store.commit('shipment_md/shipments/SET_DETAIL_ID', this.shipment.id);
          method = 'UPDATE_DATA';
        }
        return this.$store.dispatch(`shipment_md/shipments/${method}`, payload)
          .then(() => {
            setTimeout(() => {
              this.shipment.textButton = 'Success';
            }, 1e3);
          })
          .finally(() => {
            setTimeout(() => {
              this.shipment.textButton = 'Save';
              this.isBusy = false;
              this.cancelCreateShipment();
              this.loadJobs();
            }, 2e3);
          });
      }
      return false;
    },
    cancelCreateOrder() {
      this.$refs.createOrder.hide();
    },
    cancelActionCreate() {
      this.$refs.actionCreate.hide();
    },
    cancelCreateShipment() {
      this.$refs.createShipment.hide();
    },
    isAssignedBoard(board) {
      const isAssigned = ['assigned_pickup', 'assigned_delivery'].includes(board.key);
      return isAssigned;
    },
    getShipmentStatus(item) {
      let state = get(item, 'shipment.state', '');
      state = ['CREATED', 'READY_TO_LOAD', 'FINISH_LOADING'].includes(state) ? 'Preparation' : 'On Process';
      return state;
    },
    runAndReloadShipmentApi(api = '', payload = {}, callback = null) {
      this.isBusy = true;
      return this.$store.dispatch(`shipment_md/shipments/${api}`, payload)
        .then((resp) => {
          if (callback !== null) return callback(resp.data.added);
          return this.loadJobs();
        })
        .finally(() => {
          this.isBusy = false;
        });
    },
    onMoveOrder(context) {
      const orderId = context.item.id;
      const before = context.from.id;
      const after = context.to.id;

      const isBeforeShipment = context.from.id.indexOf('shipment') !== -1;
      const isAfterShipment = context.to.id.indexOf('shipment') !== -1;

      const isPickup = before === 'unassign' && after === 'assigned_pickup';
      const isUnassign = before === 'assigned_pickup' && after === 'unassign';

      if (context.from.id === context.to.id) return false;

      let api = '';
      let callback = null;
      let customerAssigned = true;
      const payload = {
        order_id: orderId,
      };

      if (!isBeforeShipment && isAfterShipment) {
        const board = this.boards.find(b => b.key === 'on_depot');
        const order = board.items.find(item => item.id === orderId);
        let newMetadata = get(order, 'metadata', {});
        if (newMetadata === null) newMetadata = {};
        newMetadata.pickup_shipment_id = get(order, 'shipment.id', null);
        newMetadata.manufacturer_id = get(order, 'customer.id', null);
        newMetadata.manufacturer_location_id = get(order, 'destination.id', null);
        newMetadata.time_in_pickup = get(order, 'metadata.time_in', null);
        newMetadata.time_out_pickup = get(order, 'metadata.time_out', null);
        newMetadata.time_in_app_pickup = get(order, 'metadata.time_in_app', null);
        newMetadata.time_out_app_pickup = get(order, 'metadata.time_out_app', null);

        customerAssigned = get(newMetadata, 'customer_id', false);

        api = 'ADD_SHIPMENT_ORDER';
        payload.shipment_id = context.to.id.replace('shipment-', '');
        callback = (shipment) => {
          const orderObj = shipment.orders.find(o => o.id === orderId);
          this.$store.commit('shipment_md/orders/SET_DETAIL_ID', orderId);
          this.$store.dispatch('shipment_md/orders/UPDATE_DATA', {
            type: 'DELIVERY',
            metadata: newMetadata,
            customer: {
              id: get(orderObj, 'metadata.customer_id', ''),
            },
            destination: {
              id: get(orderObj, 'metadata.customer_location_id', ''),
            },
          })
            .then(() => {
              this.set_shipment_after_customer.active = false;
              this.loadJobs();
            });
        };
      } else if (isBeforeShipment && !isAfterShipment) {
        api = 'REMOVE_SHIPMENT_ORDER';
        payload.shipment_id = context.from.id.replace('shipment-', '');
        callback = () => {
          this.$store.commit('shipment_md/orders/SET_DETAIL_ID', orderId);
          this.$store.dispatch('shipment_md/orders/UPDATE_DATA', { type: 'PICKUP' })
            .then(() => {
              context.item.remove();
              this.loadJobs();
            });
        };
      } else if (isBeforeShipment && isAfterShipment) {
        api = 'MOVE_SHIPMENT_ORDER';
        payload.source_shipment_id = context.from.id.replace('shipment-', '');
        payload.target_shipment_id = context.to.id.replace('shipment-', '');
      }

      if (api) {
        if (!customerAssigned) {
          this.isDelivery = true;
          this.form.type = 'DELIVERY';
          this.set_shipment_after_customer = {
            active: true,
            api,
            payload,
            callback,
          };
          return this.handleAssignOrder(orderId, 'Assign Customer For Delivery', context);
        }
        return this.runAndReloadShipmentApi(api, payload, callback);
      }

      if (isPickup) {
        const title = 'Assign For Pickup';
        this.form.type = 'PICKUP';
        return this.handleAssignOrder(orderId, title, context);
      }

      let key = '';
      if (isUnassign) {
        key = 'assigned_pickup';
      }

      const board = this.boards.find(b => b.key === key);
      const order = board.items.find(item => item.id === orderId);
      const shipmentId = get(order, 'shipment.id', '');
      const type = 'Unassign';
      this.form.context = context;

      return this.confirmRemoveOrder(orderId, shipmentId, type);
    },
    handleAssignOrder(orderId, title, context = null) {
      const board = this.boards.find(b => b.items.find(i => i.id === orderId));
      this.form.order = board.items.find(i => i.id === orderId);
      this.form.context = context;
      this.form.title = title;
      return this.$refs.vehicle.show();
    },
    handleRemoveOrder(orderId, shipmentId, type) {
      if (type === 'Unassign' || type === 'Move to Depot') {
        return this.$store.dispatch('shipment_md/shipments/REMOVE_SHIPMENT_ORDER', {
          order_id: orderId,
          shipment_id: shipmentId,
        })
          .then(() => {
            this.$store.commit('shipment_md/orders/SET_DETAIL_ID', orderId);
            Promise.all([
              this.$store.dispatch('shipment_md/orders/UPDATE_DATA', { type: 'PICKUP' }),
            ])
              .then(() => {
                this.$swal('Success', `Successfully ${type} Order.`, 'info').then(() => {
                  this.loadJobs();
                });
              })
              .finally(() => {
                this.isBusy = false;
              });
          });
      }
      return Promise.all([
        this.$store.dispatch('shipment_md/orders/DELETE_DATA_BY_SHIPMENT', shipmentId),
        this.$store.dispatch('shipment_md/shipments/DELETE_DATA', shipmentId),
      ])
        .then(() => {
          this.$swal('Success', `Successfully ${type} Order.`, 'info').then(() => {
            this.loadJobs();
          });
        })
        .finally(() => {
          this.isBusy = false;
        });
    },
    onActionMove() {
      this.$refs.order.hide();
      const type = this.selectedBoard.key;
      const orderId = get(this.selectedBoardItem, 'id', '');
      if (type === 'unassign' || type === 'on_depot') {
        const title = type === 'unassign' ? 'Assign For Pickup' : 'Assign For Deliver';
        this.form.type = type === 'unassign' ? 'PICKUP' : 'DELIVERY';
        return this.handleAssignOrder(orderId, title);
      } else if (type === 'assigned_pickup' || type === 'assigned_delivery') {
        const shipmentId = get(this.selectedBoardItem, 'shipment.id', '');
        const typeText = type === 'assigned_pickup' ? 'Unassign' : 'Move to Depot';
        return this.confirmRemoveOrder(orderId, shipmentId, typeText);
      }
      return false;
    },
    cancelAssignOrder() {
      if (this.form.context) this.form.context.from.appendChild(this.form.context.item);
      if (this.$refs.vehicle) this.$refs.vehicle.hide();
      this.confirmDeleteOrder = false;
      this.form = {
        edit: false,
        title: '',
        textButton: 'Save',
        context: null,
        vehicle: null,
        order: null,
        type: null,
        destinations: [],
        customer: null,
        destination: null,
      };
      this.isDelivery = false;
    },
    assignOrder() {
      let isVehicle = true;
      let isCustomer = true;
      let isDestination = true;

      if (this.isDepotAndEmptyCustomer) {
        isCustomer = !isEmpty(this.form.customer);
        isDestination = !isEmpty(this.form.destination);
      } else {
        isVehicle = !isEmpty(this.form.vehicle);
      }

      if (isVehicle && isCustomer && isDestination) {
        this.form.textButton = 'Saving';
        if (this.form.edit) {
          const shipmentId = get(this.form.order, 'shipment.id', '');
          this.$store.commit('shipment_md/shipments/SET_DETAIL_ID', shipmentId);
          const payload = {
            vehicle: this.form.vehicle,
          };
          if (this.form.vehicle.driver) payload.driver_id = get(this.form.vehicle, 'driver.id', '');
          return this.$store.dispatch('shipment_md/shipments/UPDATE_DATA', payload)
            .then(() => {
              setTimeout(() => {
                this.form.textButton = 'Success';
              }, 1e3);
            })
            .finally(() => {
              setTimeout(() => {
                this.cancelAssignOrder();
                this.loadJobs();
              }, 2e3);
            });
        }
        let api = 'ASSIGN_VEHICLE_JOB';
        const payload = {};
        if (this.isDepotAndEmptyCustomer) {
          api = 'UPDATE_DATA';
          this.$store.commit('shipment_md/orders/SET_DETAIL_ID', this.form.order.id);
          let metadata = get(this.form, 'order.metadata', {});
          if (metadata === null) metadata = {};
          metadata.customer_id = this.form.customer.id;
          metadata.customer_location_id = this.form.destination.id;
          payload.metadata = metadata;
          payload.customer = this.form.customer;
        } else {
          payload.order_id = this.form.order.id;
          payload.type = this.form.type;
          payload.vehicle_id = this.form.vehicle.id;
        }
        if (!isEmpty(this.notif.customer) && this.checkIfValidaEmail(this.notif.customer)) {
          payload.metadata = payload.metadata || {};
          payload.metadata.email_notification = payload.metadata.email_notification || {};
          payload.metadata.email_notification.customer = this.notif.customer;
        }
        return this.$store.dispatch(`shipment_md/orders/${api}`, payload)
          .then(() => {
            setTimeout(() => {
              this.form.textButton = 'Success';
            }, 1e3);
          })
          .finally(() => {
            setTimeout(() => {
              this.cancelAssignOrder();
              this.loadJobs().then(() => {
                const {
                  active,
                  api: apiShipment,
                  payload: payloadShipment,
                  callback,
                } = this.set_shipment_after_customer;
                if (active) {
                  this.runAndReloadShipmentApi(apiShipment, payloadShipment, callback);
                }
                this.loadJobsInfo(true);
              });
              return true;
            }, 2e3);
          });
      }

      return false;
    },
    onClickDeleteOrder(order) {
      const orderId = order.id;
      const shipmentId = get(order, 'shipment.id', '');
      const type = 'Delete';
      return this.confirmRemoveOrder(orderId, shipmentId, type);
    },
    onClickEditOrder(order) {
      this.form.order = order;
      this.form.vehicle = get(order, 'shipment.vehicle', {});
      this.form.title = 'Update Order';
      this.form.edit = true;
      this.$refs.vehicle.show();
    },
    confirmRemoveOrder(orderId, shipmentId, type) {
      return this.$swal({
        title: 'Delete Confirmation',
        html: `Are you sure want to <b>${type}</b> this order?`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        showCloseButton: true,
      }).then((result) => {
        if (result.value) {
          if (this.isBusy) return false;
          this.confirmDeleteOrder = true;
          this.isBusy = true;
          return this.handleRemoveOrder(orderId, shipmentId, type);
        }
        return this.cancelAssignOrder();
      });
    },
    openOrderModal(board, item) {
      this.activity.textButton = 'Hide Details';
      this.selectedBoard = board;
      this.selectedBoardItem = item;
      this.$refs.order.show();

      const { destination } = item;
      const { longitude, latitude } = destination;
      this.map.bounds = L.latLngBounds([{ longitude, latitude }].map(pt => (
        { lat: pt.latitude, lng: pt.longitude }
      )));

      this.map.state = 'loading';
      setTimeout(() => {
        this.map.state = 'ready';
      }, 5e2);

      this.loadingHistory = true;
      this.$store.dispatch('shipment_md/orders/LOAD_JOB_HISTORY', item.id)
        .then((histories) => {
          this.orderHistories = histories;
          setTimeout(() => {
            this.loadingHistory = false;
            this.activity.show = true;
          }, 5e2);
        });
    },
    getMapStyle() {
      const height = window.innerHeight - (window.innerHeight * 0.6);
      const style = `height: ${height}px; width: 100%;`;
      return style;
    },
    getMarkerPoint() {
      const { location } = this.actionCreate;
      const { longitude, latitude } = location;
      return {
        lat: latitude,
        lng: longitude,
      };
    },
    getMarkerIcon() {
      const icon = L.icon({
        iconUrl: 'https://unpkg.com/leaflet@1.2.0/dist/images/marker-icon.png',
        iconSize: [25, 41],
        iconAnchor: [12.5, 32],
      });
      return icon;
    },
    getLatLng() {
      const { destination } = this.selectedBoardItem;
      const { longitude, latitude } = destination;
      return { lat: latitude, lng: longitude };
    },
    getIcon() {
      const icon = L.icon({
        iconUrl: 'https://unpkg.com/leaflet@1.2.0/dist/images/marker-icon.png',
        iconSize: [25, 41],
        iconAnchor: [12.5, 32],
      });
      return icon;
    },
    onMapReady() {
      setTimeout(() => {
        window.map = this.$refs.map;
        this.$refs.map.mapObject.invalidateSize();
        this.$refs.map.mapObject.setZoom(5);
      }, 1e2);
    },
    toggleActivity() {
      this.activity.show = !this.activity.show;
      this.activity.textButton = this.activity.show ? 'Hide Details' : 'Show Details';
    },
    formatTextKey(key) {
      const toPopoper = text => startCase(camelCase(text));
      return toPopoper(key.replaceAll('_', ' '));
    },
    formatHistory(history) {
      const { action_by, action_name, action_date } = history;
      return `
        <div><b>${action_by}</b> ${action_name}</div>
        <div class="text-muted small">${action_date}</div>
      `;
    },
    getMoveText() {
      if (this.selectedBoard.key === 'unassign') return 'Pickup';
      if (this.selectedBoard.key === 'assigned_pickup') return 'Unassign';
      if (this.selectedBoard.key === 'on_depot') return 'Deliver';
      if (this.selectedBoard.key === 'assigned_delivery') return 'Depot';
      return '';
    },
    deleteOrder() {
      if (
        this.selectedBoard.key === 'assigned_pickup' ||
        this.selectedBoard.key === 'assigned_delivery') {
        return this.onClickDeleteOrder(this.selectedBoardItem)
          .then(() => {
            if (this.confirmDeleteOrder) {
              setTimeout(() => {
                this.$refs.order.hide();
              }, 1e3);
            }
          });
      }
      return this.$swal({
        title: 'Delete Confirmation',
        html: 'Are you sure want to <b>delete</b> this order?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        showCloseButton: true,
      }).then((result) => {
        if (result.value) {
          this.$store.dispatch('shipment_md/orders/DELETE_DATA', this.selectedBoardItem.id).then(() => {
            setTimeout(() => {
              this.$swal('Success', 'Successfully delete order.', 'info').then(() => {
                this.$refs.order.hide();
                setTimeout(() => {
                  this.loadJobs();
                }, 1e3);
              });
            }, 1e3);
          });
        }
      });
    },
    onActionCreateMapReady() {
      const vm = this;
      setTimeout(() => {
        window.actionCreateMap = vm.$refs.actionCreateMap;
        vm.$refs.actionCreateMap.mapObject.invalidateSize();
        vm.$refs.actionCreateMap.mapObject.setZoom(5);
      }, 1e2);
    },
    searchLocation: debounce((context, value) => {
      context.$store.dispatch('shipment_md/locations/SEARCH_ADDRESS', value).then((location) => {
        if (!isEmpty(location)) {
          context.actionCreate.location.openSuggestion = true;
          context.actionCreate.location.suggestion = find(location);
        }
      });
    }, 300, {
      leading: false,
    }),
    selectLocation() {
      const { geometry } = this.actionCreate.location.suggestion;
      const { location: { lat, lng } } = geometry;
      this.actionCreate.map.center = [lat, lng];
      this.actionCreate.location.longitude = lng;
      this.actionCreate.location.latitude = lat;
      this.actionCreate.location.query = '';
      this.actionCreate.location.openSuggestion = false;
      this.actionCreate.location.finish = true;
    },
    isCancelledOrder(board, order) {
      if (board.key === 'assigned_pickup' || board.key === 'assigned_delivery') {
        const metadata = get(order, 'metadata', {});
        const isRejected = get(metadata, 'rejected', false);
        const isAbort = get(metadata, 'abort', false);
        return isRejected || isAbort;
      }
      return false;
    },
    setManufacturerDestinations(manufacturerId) {
      const manuId = isEmpty(manufacturerId) ? get(this.order, 'manufacturer.id', null) : manufacturerId;
      this.manufacturerDestinations.splice(0);
      this.manufacturerDestinations = filter(this.locations, { company: { id: manuId } });
      if (!isEqual(manuId, get(this.order.manufacturer_destination, 'company.id'))) {
        this.order.manufacturer_destination = {};
      }
    },
    setCustomerDestinations(customerId) {
      const custId = isEmpty(customerId) ? get(this.order, 'customer.id', null) : customerId;
      this.customerDestinations.splice(0);
      this.customerDestinations = filter(this.locations, { company: { id: custId } });
      if (!isEqual(custId, get(this.order.customer_destination, 'company.id'))) {
        this.order.customer_destination = {};
      }
    },
    checkIfValidaEmail(email) {
      return email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/);
    },
    setEmailNotif(type) {
      if (type === 'manufacturer') {
        if (this.checkIfValidaEmail(this.notif.manufacturer)) {
          this.notif.manufacturerTextButton = this.notif.manufacturerTextButton === 'Change' ? 'Set Email' : 'Change';
        }
      } else if (this.checkIfValidaEmail(this.notif.customer)) {
        this.notif.customerTextButton = this.notif.customerTextButton === 'Change' ? 'Set Email' : 'Change';
      }
    },
    isSetCustomer() {
      if (!this.order.set_customer) this.order.job_type = false;
    },
  },
};
</script>
<style scoped>
.top-rounded {
  border-top-left-radius: 0.25rem !important;
  border-top-right-radius: 0.25rem !important;
}
.list-group {
  border-bottom: none;
}
.list-group > div:empty::after,
.bg-success > .card-body:empty::after {
  content: 'There\'s No Order';
  display: block;
  margin-bottom: 1.1rem;
  width: 100%;
  text-align: center;
  margin-top: 0.7rem;
}
.list-group-item {
  background: white;
  min-height: 3.2em;
  border: 1px solid #e2e2e2;
  margin-bottom: 8px;
  box-shadow: 0px 2px 7px 0px rgb(50 50 50 / 15%);
  touch-action: none;
  border-radius: 5px;
}
.list-group-item:last-child {
  margin-bottom: 0px !important;
}
.list-group-item .card-text {
  cursor: pointer;
}
.dropdown-button >>> .dropdown-toggle {
  padding: 0 !important;
  color: #29363d !important;
  margin-top: 0px !important;
}
.activity td {
  white-space: nowrap;
  vertical-align: baseline;
}
.activity td:first-child {
  padding-right: 10px;
}
.address_query {
  z-index: 1000;
  max-width: 500px;
  position: absolute;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  top: 12px;
}
</style>
<style lang="sass" scoped>
@import "~leaflet/dist/leaflet.css";
.leaflet-draw-toolbar a
  background-image: url('~static/img/leaflet/spritesheet.png');
.input-address
  position: absolute;
  z-index: 1000;
#suggestion
  z-index: 1000
  max-width: 500px
  position: absolute
  margin-left: auto
  margin-right: auto
  left: 0
  right: 0
  top: 45px
.s-40
  height: 40px
</style>



// WEBPACK FOOTER //
// src/views/pages/shipment_md/orders/OrderDelivery.vue